"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatVodData = void 0;
/*
 * VOD视频上传数据处理
 */
const formatVodData = val => {
  try {
    const data = JSON.parse(val);
    return data;
  } catch (err) {
    return {
      url: val,
      alt: ''
    };
  }
};
exports.formatVodData = formatVodData;